module.exports = __webpack_public_path__ + "static/car-pc/img/price.2b6c6373.svg";